<!-- 漏损率分析 -->
<template>
  <a-card :bordered="false" :bodyStyle="{ padding: '16px 36px', height: '100%' }" :style="{ height: '100%' }">
    <a-form-model :layout="'inline'">
      <a-row>
        <a-col :span="5">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分区名称">
            <a-tree-select
              :tree-data="zoneTreeData"
              v-model="query.zoneId"
              style="width: 250px"
              :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              placeholder="请选择片区"
              allow-clear
              :treeDefaultExpandedKeys="treeDefaultExpandedKeys"
              show-search
            ></a-tree-select>
          </a-form-item>
        </a-col>

        <a-col :span="7">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="时间" style="display: flex">
            <a-radio-group v-model="timetype" button-style="solid" @change="timetypeChange">
              <a-radio-button value="2">年份</a-radio-button>
              <a-radio-button value="1">季度</a-radio-button>
              <a-radio-button value="0">月份</a-radio-button>
              <a-radio-button value="">其他</a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="4" style="margin-top: 4px; margin-left: -90px">
          <!-- 季度 -->
          <div v-if="query.degreeType == 1" style="display: flex">
            <a-date-picker
              placeholder="请选择日期"
              :allowClear="false"
              v-model="query.queryBeginTime"
              :format="selectFormat"
              :valueFormat="valueFormat"
              :mode="selectMode"
              :open="queryBeginOpen"
              @openChange="queryBeginOpenChange"
              @panelChange="queryBeginPanelChange"
            />
            <a-select
              v-if="query.degreeType == 1"
              default-value="1"
              style="width: 120px; margin-left: 10px"
              v-model="queryBeginQuarter"
            >
              <a-select-option :value="1">第一季度</a-select-option>
              <a-select-option :value="2">第二季度</a-select-option>
              <a-select-option :value="3">第三季度</a-select-option>
              <a-select-option :value="4">第四季度</a-select-option>
            </a-select>

            <!-- <a-date-picker
              style="margin-left: 10px"
              placeholder="请选择日期"
              :allowClear="false"
              :valueFormat="valueFormat"
              v-model="query.queryEndTime"
              :format="selectFormat"
              :mode="selectMode"
              :open="queryEndOpen"
              @openChange="queryEndOpenChange"
              @panelChange="queryEndPanelChange"
            />
            <a-select
              v-if="query.degreeType == 1"
              default-value="1"
              style="width: 120px; margin-left: 10px"
              v-model="queryEndQuarter"
            >
              <a-select-option :value="1">第一季度</a-select-option>
              <a-select-option :value="2">第二季度</a-select-option>
              <a-select-option :value="3">第三季度</a-select-option>
              <a-select-option :value="4">第四季度</a-select-option>
            </a-select> -->
          </div>
          <!-- 年/ 月 -->
          <div v-else-if="query.degreeType == 2 || query.degreeType === 0" style="display: flex">
            <!-- <a-range-picker
              :placeholder="['开始日期', '截止日期']"            
              v-model="timearr"
              :format="['YYYY', 'YYYY']"
              :valueFormat="valueFormat"
              :mode="['year', 'year']"
              @panelChange="timearrPanelChange" 
             /> -->
            <a-date-picker
              placeholder="开始日期"
              :allowClear="false"
              v-model="query.queryBeginTime"
              :format="selectFormat"
              :valueFormat="valueFormat"
              :mode="selectMode"
              :open="queryBeginOpen"
              @openChange="queryBeginOpenChange"
              @panelChange="queryBeginPanelChange"
            />
            <a-date-picker
              placeholder="结束日期"
              :allowClear="false"
              v-model="query.queryEndTime"
              :format="selectFormat"
              :valueFormat="valueFormat"
              :mode="selectMode"
              :open="queryEndOpen"
              @openChange="queryEndOpenChange"
              @panelChange="queryEndPanelChange"
            />
          </div>
          <!-- 月 -->
          <!-- <div v-else-if="query.degreeType === 0">
            <a-range-picker
              :placeholder="['开始日期', '截止日期']"
              :allowClear="false"
              v-model="timearr"
              :format="['YYYY-MM', 'YYYY-MM']"
              :valueFormat="valueFormat"
              :mode="['month', 'month']"
              @panelChange="timearrPanelChange"
            />
          </div> -->
          <!-- 其他 -->
          <div v-else>
            <a-range-picker
              :placeholder="['开始日期', '截止日期']"
              :allowClear="false"
              v-model="timearr"
              :format="['YYYY-MM-DD', 'YYYY-MM-DD']"
              :valueFormat="valueFormat"
              :mode="['date', 'date']"
              @panelChange="timearrPanelChange"
            />
          </div>
        </a-col>
      </a-row>
    </a-form-model>

    <a-row :gutter="48" style="margin: 15px 0 0 -20px">
      <a-col :md="24" :sm="24">
        <a-button type="primary" @click="queryList">查询</a-button>
        <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
        <a-button type="primary" style="margin-left: 8px" @click="exportHandleIdList">导出</a-button>
        <!-- <a-button type="primary" style="margin-left: 8px" @click="editContent" :disabled="editBtn">编辑</a-button>
        <a-button type="primary" style="margin-left: 8px" @click="batchShowhide">数据恢复</a-button> -->
        <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()">删除</a-button>
      </a-col>
    </a-row>
    <a-table
      style="margin-top: 20px"
      rowKey="id"
      bordered
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="{ pageSize: 50, current: 0, showSizeChanger: true }"
    >
      <!-- <span slot="zhlsl" slot-scope="text, record">
        {{ (((record.waterSupply - record.salesVolume) / record.waterSupply) * 100).toFixed(2) }}
      </span> -->
    </a-table>

    <!-- 显隐恢复 -->
    <a-modal v-model="showVisible" class="x-y-h-f" width="80vw" title="显隐修改" @ok="handleShowOk">
      <a-table
        style="margin-top: 20px"
        rowKey="id"
        bordered
        :row-selection="{ selectedRowKeys: this.showSelectedRows, onChange: onShowHideSelectChange }"
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
        :data-source="showList"
        :columns="columns"
        :loading="dataListLoading"
        :pagination="{ pageSize: 50, current: 0, showSizeChanger: true }"
      >
      </a-table>
    </a-modal>

    <!-- 编辑修改 -->
    <a-modal v-model="editVisible" width="44vw" title="漏损率编辑" @ok="handleEditOk">
      <Leakageratetemplate ref="LeakageratetemplateRef" :formStatus="'edit'" @closePopup="closePopupModal">
      </Leakageratetemplate>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import axios from 'axios'
import Leakageratetemplate from './Leakageratetemplate.vue'
import moment from 'moment'
import storage from 'store'
const columns = [
  {
    title: '时间',
    dataIndex: 'time',
    width: '140px',
  },
  {
    title: '片区',
    dataIndex: 'zoneName',
    width: '170px',
  },
  {
    title: '供水量(m³)',
    dataIndex: 'waterSupply',
  },
  {
    title: '自产水量(m³)',
    dataIndex: 'selfProducedWater',
  },
  {
    title: '外购水量(m³)',
    dataIndex: 'purchasedWater',
  },
  {
    title: '售水量(m³)',
    dataIndex: 'salesVolume',
  },
  {
    title: '收费已计量(m³)',
    dataIndex: 'chargesMetered',
  },
  {
    title: '收费未计量(m³)',
    dataIndex: 'chargesNotMetered',
  },
  {
    title: '未收费已计量(m³)',
    dataIndex: 'notChargedMetered',
  },
  {
    title: '未收费未计量(m³)',
    dataIndex: 'notChargedNotMetered',
  },
  {
    title: '其他水量(m³)',
    dataIndex: 'otherWaterVolumes',
  },

  {
    title: '综合漏损率(%)',
    dataIndex: 'comprehensiveLeakageRate',
  },
  {
    title: '漏损率(%)',
    dataIndex: 'leakageRate',
  },
]

export default {
  name: 'Analysis',
  mixins: [mixinViewModule],
  components: { Leakageratetemplate },
  data() {
    return {
      timearr: [],
      treeDefaultExpandedKeys: [], //默认展开的树节点
      valueFormat: 'YYYY',
      timetype: '2',
      showDataListLoading: false,
      showVisible: false,
      showList: [],
      showSelectedRows: [],
      showSelectionList: [],
      showRestoreList: [],
      editVisible: false,
      editBtn: false,
      exportDataUrl: `pipe-network/zone_leakages/export`,
      exportLoading: false,
      md: 6,
      query: {
        zoneId: undefined,
        degreeType: 2,
        queryBeginTime: '',
        queryEndTime: '',
        contrastBeginTime: '',
        contrastEndTime: '',
      },
      record: {},
      confirmLoading: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
      },
      queryUrl: '/pipe-network/zone_leakages/page',
      queryZoneDateUrl: 'zone-metering/zone-metering',
      upBatchUrl: '/pipe-network/zone_leakages/status',
      deleteUrl: '/pipe-network/zone_leakages', //删除按钮接口地址
      zoneTreeData: [],
      selectFormat: 'YYYY',
      selectMode: 'year',
      queryBeginOpen: false,
      queryEndOpen: false,
      queryBeginQuarter: 1,
      queryEndQuarter: 1,
      contrastBeginOpen: false,
      querytimeOpen: true,
      columns,
    }
  },

  watch: {
    selectedRows(nv, ov) {
      nv.length > 1 ? (this.editBtn = true) : (this.editBtn = false)
    },
  },
  methods: {
    moment,
    // 关闭弹窗
    closePopupModal() {
      this.editVisible = false
    },
    // 显隐恢复
    handleShowOk() {
      this.showList.forEach((element) => {
        element.ifDisplay = 1
      })
      this.showSelectedRows.forEach((item) => {
        this.showList.forEach((element) => {
          if (item === element.id) {
            element.ifDisplay = 2
          }
        })
      })
      this.$http
        .post(this.upBatchUrl, this.showList)
        .then((res) => {
          if (res.code === 0) {
            this.showVisible = false
            this.queryList()
          }
        })
        .catch(() => {})
    },
    // 保存
    handleEditOk() {
      this.$nextTick(() => this.$refs.LeakageratetemplateRef.updateData())
    },
    // 编辑
    editContent() {
      if (this.selectedRows.length > 0) {
        this.editVisible = true
        let sitem = {}
        this.list.forEach((element) => {
          if (this.selectedRows[0] === element.id) {
            sitem = element
          }
        })
        this.$nextTick(() => this.$refs.LeakageratetemplateRef.setFormData(sitem))
      } else {
        this.$message.success('请选中一条数据')
      }
    },
    // 显示隐藏
    batchShowhide() {
      this.showVisible = true
      this.queryList('all')
    },
    difference(aArray, bArray) {
      const bArraySet = new Set(bArray)
      const resultArray = aArray.filter((item) => !bArraySet.has(item))
      return Array.from(resultArray)
    },
    // 选择中改变
    onShowHideSelectChange(val) {
      this.showSelectedRows = val
    },
    chuli(n) {
      if (n != null && n.length !== 0) {
        n.map((item) => {
          item.children = this.chuli(item.children)
          if (item.level == 1) {
            this.treeDefaultExpandedKeys.push(item.id)
          }
        })
        return n
      } else {
        return n
      }
    },
    exportHandleIdList() {
      let data = {
        // responseType: 'arraybuffer',
        // headers: this.uploadHeader,

        idList: this.selectedRows,
        zoneLeakageQuery: {
          ...this.query,
        },
      }
      this.exportLoading = true
      this.query.idList = this.selectedRows
      const tenantId = storage.get('tenantId')
      const head = this.uploadHeader.Authorization
      const url = `${process.env.VUE_APP_API_BASE_URL}${this.exportDataUrl}`
      const instance = axios.create({
        // 设置基本的请求配置，如基本URL、请求超时时间等
        baseURL: url,
      })
      instance.defaults.responseType = 'arraybuffer'
      instance
        .post(url, data, {
          headers: {
            responseType: 'arraybuffer',
            Authorization: head,
            'tenantId': tenantId
          },
        })
        .then((res) => {
          const blob = new Blob([res.data], {
            type: 'application/octet-stream;charset=utf-8',
          })
          const fileName = this.exportFileName || '导出数据.xlsx'
          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)
          this.$message.success('导出完成')
          this.exportLoading = false
        })
        .catch(() => {
          this.exportLoading = false
        })
    },

    resetList() {
      this.selectedRows = []
      this.query = {
        zoneId: '',
        degreeType: this.query.degreeType,
        queryBeginTime: '',
        queryEndTime: '',
        contrastBeginTime: '',
        contrastEndTime: '',
      } 
      this.timearr = ['', '']
      this.queryList()
    },
    queryList(str) {
      console.log(this.timearr)
      if (str === 'all') {
        this.showSelectedRows = []
        this.showSelectionList = []
        this.showRestoreList = []
        this.showList = []
      }
      delete this.query.idList
      delete this.query.zoneLeakageQuery

      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.query,
      }
      typeof params.queryBeginTime === 'string' ? '' : (params.queryBeginTime = params.queryBeginTime)
      typeof params.queryEndTime === 'string' ? '' : (params.queryEndTime = params.queryEndTime)

      typeof params.contrastBeginTime === 'string' ? '' : (params.contrastBeginTime = params.contrastBeginTime)
      // typeof params.contrastEndTime === 'string' ? '' : (params.contrastEndTime = params.contrastEndTime)
      params.contrastEndTime ? (params.contrastBeginTime += '-' + this.contrastBeginTime) : ''

      if (params.degreeType === 1) {
        //季度
        params.queryBeginTime ? (params.queryBeginTime += '-' + this.queryBeginQuarter) : ''
        params.queryEndTime ? (params.queryEndTime += '-' + this.queryEndQuarter) : ''
        // params.contrastBeginTime ? (params.contrastBeginTime += '-' + this.contrastBeginQuarter) : ''
        // params.contrastEndTime ? (params.contrastEndTime += '-' + this.contrastEndOpen) : ''
      } 
      // else if (params.degreeType!='') {
      //   params.queryBeginTime = this.timearr[0]
      //   params.queryEndTime = this.timearr[1]
      // }

      else if (params.degreeType === '') {
 console.log('ko');
         params.queryBeginTime = this.timearr[0]
         params.queryEndTime = this.timearr[1]
      }

      if (this.needPage) {
        params.page = 1
        this.pagination.current = 1
        params.limit = 50
      }
      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, { params })
        .then(({ data }) => {
          this.dataListLoading = false
          const listDate = data.list || []
          this.pagination.total = data.total ? parseInt(data.total) : 0
          const arr = []
          const arr1 = []
          listDate.map((item) => {
            arr.push(item)
            // if (item.ifDisplay === 1) {
            //   arr.push(item)
            // } else {
            //   arr1.push(item.id)
            // }
            item.waterSupply = parseFloat(item.waterSupply).toFixed(0)
            item.measuredWaterVolume = parseFloat(item.measuredWaterVolume).toFixed(0)
            item.freeWater = parseFloat(item.freeWater).toFixed(0)
            item.municipalWaterVolume = parseFloat(item.municipalWaterVolume).toFixed(0)
          })
          this.showSelectedRows = arr1
          this.list = arr
          if (str === 'all') {
            this.showList = listDate
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    queryEndOpenChange(status) {
      if (status) {
        this.queryEndOpen = true
      } else {
        this.queryEndOpen = false
      }
    },
    queryEndPanelChange(value) {
      if (this.query.degreeType == 2) {
        this.query.queryEndTime = value.format('YYYY')
      } else {
        this.query.queryEndTime = value.format(this.selectFormat)
      }
      this.queryEndOpen = false
    },
    queryBeginOpenChange(status) {
      if (status) {
        this.queryBeginOpen = true
      } else {
        this.queryBeginOpen = false
      }
    },

    queryBeginPanelChange(value) {
      console.log(value, this.selectFormat)
      if (this.query.degreeType == 2) {
        this.query.queryBeginTime = value.format('YYYY')
      } else {
        this.query.queryBeginTime = value.format(this.selectFormat)
      }
      this.queryBeginOpen = false
    },
    timearrPanelChange(val, mode) {
      if (this.query.degreeType == 2) {
        this.timearr = [val[0].format('YYYY'), val[1].format('YYYY')]
      } else if (this.query.degreeType === 0) {
        this.timearr = [val[0].format('YYYY-MM'), val[1].format('YYYY-MM')]
      } else {
        this.timearr = [val[0].format('YYYY-MM-DD'), val[1].format('YYYY-MM-DD')]
      }
      this.querytimeOpen = false
      console.log(this.timearr, mode)
    },
    // 更新数据
    timetypeChange() {

      let key = this.timetype
      this.selectedRows = []
      this.showSelectedRows = []
      if (key == 2) {
        this.query = {
          zoneId: undefined,
          degreeType: 2,
          queryBeginTime: '',
          queryEndTime: '',
          contrastBeginTime: '',
          contrastEndTime: '',
        }
        this.selectFormat = ['YYYY', 'YYYY']

        this.valueFormat = 'YYYY'
        this.selectMode = 'year'

        this.md = 6
      } else if (key == 1) {
        this.query = {
          zoneId: undefined,
          degreeType: 1,
          queryBeginTime: '',
          queryEndTime: '',
          contrastBeginTime: '',
          contrastEndTime: '',
        }
        this.selectFormat = 'YYYY'
        this.valueFormat = 'YYYY'

        this.selectMode = 'year'

        this.md = 8
      } else if (key == '0') {
        this.query = {
          zoneId: undefined,
          degreeType: 0,
          queryBeginTime: '',
          queryEndTime: '',
          contrastBeginTime: '',
          contrastEndTime: '',
        }
        this.selectFormat = 'YYYY-MM'
        this.valueFormat = 'YYYY-MM'

        this.selectMode = 'month'

        this.md = 6
      } else {
        //其他
        this.selectFormat = 'YYYY-MM-DD'
        this.valueFormat = 'YYYY-MM-DD'
        this.query.degreeType = ''
        this.selectMode = 'date'
      }

      console.log(this.selectFormat)
      this.queryList()
    },
    getZoneData() {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
        this.chuli(this.zoneTreeData)
      })
    },
  },
  created() {
    this.getZoneData()
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>

<style>
.x-y-h-f .ant-modal {
  top: 10px;
}

.x-y-h-f .ant-modal-wrap {
  overflow: hidden;
}
</style>
